<template>
	<div class="header-wrapper" ref="hw">
		<div class="mask" v-if="isShow" @click.self="onClose"></div>
		<div class="header-container">
			<div class="hamburger" @click="onHambur">
				<div class="menu">
					<span class="iconfont icon-xuanxiang"></span>
				</div>
			</div>
			<div class="nav-bar-middle" v-if="isShow">
				<div class="nav-close" @click="isShow = !isShow">
					<span class="iconfont icon-guanbi"></span>
				</div>
				<div class="nav-logo" @click="onNavProduct('/index')">
					<img src="../../static/img/logo.png" class="logo">
				</div>
				<div class="nav-menu  scale-up-ver-top">
					<div class="nav-item">
						<a href="javascript: void (0)" class="nav-text">
							<span>{{ $t('header.products') }}</span>
							<i class="iconfont icon-shangjiantou"></i>
						</a>
						<div class="nav-link-list">
							<div class="link" @click="onNavProduct('/tanixw2')">
								<a href="javascript: void (0)">Tanix W2</a>
							</div>
							<div class="link" @click="onNavProduct('/x96q')">
								<a href="javascript: void (0)">X96Q</a>
							</div>
							<div class="link" @click="onNavProduct('/auroraElite')">
								<a href="javascript: void (0)">Aurora Elite</a>
							</div>
							<div class="link" @click="onNavProduct('/auroraw2')">
								<a href="javascript: void (0)">Aurora W2</a>
							</div>
						</div>
					</div>
					<div class="nav-item">
						<a href="javascript: void (0)" class="nav-text" @click="onNavProduct('/videoGuidance')">
							<span>{{ $t('header.vg')}}</span>
						</a>
					</div>
					<div class="nav-item">
						<a href="javascript: void (0)" class="nav-text">
							<span>{{ $t('header.download')}}</span>
							<i class="iconfont icon-shangjiantou"></i>
						</a>
						<div class="nav-link-list">
							<div class="link" @click="navRemote(1)">
								<a href="javascript: void (0)">Aurora Remote</a>
							</div>
							<div class="link" @click="navRemote(2)">
								<a href="javascript: void (0)">Mcstore</a>
							</div>
						</div>
					</div>
					<div class="nav-item">
						<a href="javascript: void (0)" class="nav-text" @click="onNavProduct('/about')">
							<span>{{ $t('header.about')}}</span>
						</a>
					</div>
				</div>
			</div>
			<div @click="onNavProduct('/index')" class="logo-wrap">
				<img src="../../static/img/logo.png" class="logo">
			</div>
			<div class="locales-inner">
				<div>
					<span class="iconfont icon-yuyan" @click="onLanguage"></span>
				</div>
				<div class="nav-dropdown scale-up-ver-top" v-show="isLanguage">
					<div class="dropdown-item" v-for="l in lang" :key="l.lang" @click="changLang(l.lang)">
						<a href="javascript: void (0)" class="nav-link external"
							:class="currentLang === l.lang ? 'selected': ''">{{ l.name }}</a>
					</div>
				</div>
			</div>
			<div class="navbar navbar-with-link">
				<div class="nav-product navLink" @mouseenter="onDownLoad" @mouseleave="onDownLoad">
					<a href="javascript: void (0)" class="nav-text">
						<span>{{ $t('header.download')}}</span>
						<i class="iconfont icon-jiantous"></i>
					</a>
					<div class="nav-dropdown" v-show="isDownload"
						:class="isDownload ? 'scale-up-ver-top' : 'scale-out-ver-top'">
						<div class="dropdown-item"  @click="onNavProduct('/remote')">
							<a href="javascript: (0)" class="nav-link external">Aurora remote</a>
						</div>
						<div class="dropdown-item" @click="onNavProduct('/mcstore')">
							<a href="javascript: void (0)" class="nav-link external">Mcstore</a>
						</div>
					</div>
				</div>
				<div class="nav-product" @mouseenter="onProducts" @mouseleave="onProducts">
					<a href="javascript: void (0)" class="nav-text">
						<span>{{ $t('header.products')}}</span>
						<i class="iconfont icon-jiantous"></i>
					</a>
					<div class="nav-dropdown" v-show="isProduct"
						:class="isProduct ? 'scale-up-ver-top' : 'scale-out-ver-top'">
						<div class="dropdown-item" @click="onNavProduct('/tanixw2')">
							<a href="javascript: void (0)" class="nav-link external">Tanix W2</a>
						</div>
						<div class="dropdown-item" @click="onNavProduct('/x96q')">
							<a href="javascript: void (0)" class="nav-link external">X96Q</a>
						</div>
						<div class="dropdown-item" @click="onNavProduct('/auroraElite')">
							<a href="javascript: void (0)" class="nav-link external">Aurora Elite</a>
						</div>
						<div class="dropdown-item" @click="onNavProduct('/auroraw2')">
							<a href="javascript:  (0)" class="nav-link external">Aurora W2</a>
						</div>
					</div>
				</div>
				<div class="nav-product video">
					<a href="javascript: void (0)" @click="onNavProduct('/videoGuidance')">{{ $t('header.vg')}}</a>
				</div>
				<div class="about">
					<a href="javascript: void (0)" class="nav-text" @click="onNavProduct('/about')">
						<span>{{ $t('header.about') }}</span>
					</a>
				</div>
				<div class="language-wrap">
					<div class="locales" @click="onLanguage">
						<i class="iconfont icon-yuyan"></i>
						<span>{{ i18n_name }}</span>
						<i class="iconfont icon-jiantous"></i>
					</div>
					<div class="nav-dropdown scale-up-ver-top" v-show="isLanguage">
						<div class="dropdown-item" v-for="l in lang" :key="l.lang" @click="changLang(l.lang)">
							<a href="javascript: void (0)" class="nav-link external"
								:class="currentLang === l.lang ? 'selected': ''">{{ l.name }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		name: 'tvHeader',
		data() {
			return {
				lang: [{
						name: 'русский',
						lang: 'ru_RU'
					},
					{
						name: 'English',
						lang: 'en_US'
					},
					{
						name: 'Portuguese',
						lang: 'pt_BR'
					},
					{
						name: '简体中文',
						lang: 'zh_CN'
					}
				],
				isShow: false,
				isProduct: false,
				isDownload: false,
				isLanguage: false,
				currentLang: 'ru_RU'
			};
		},
		computed: {
			i18n_name() {
				return this.lang.filter(item => item.lang === this.currentLang)[0].name
			}
		},
		methods: {
			onProducts() {
				this.isProduct = !this.isProduct
				this.isLanguage = false
			},
			// 产品导航
			onNavProduct(path) {
				if (this.$route.path !== path) {
					this.$router.push(path)
				}
				this.isProduct = false
			},
			// 语言
			onLanguage() {
				this.isLanguage = !this.isLanguage
			},
			changLang(lang) {
				localStorage.setItem('TV_LANGUAGE', lang)
				this.$i18n.locale = lang
				this.currentLang = lang
				this.isLanguage = !this.isLanguage
			},
			onHambur() {
				this.isLanguage = false
				this.isShow = !this.isShow
			},
			onClose() {
				this.isShow = !this.isShow
			},
			onDownLoad() {
				this.isDownload = !this.isDownload
			},
			navRemote (type) {
				let path = type == 1 ? '/remote' : '/mcstore'
				this.$router.push({
					path
				})
			}
		},
		created() {

		},
		mounted() {
			this.$nextTick(() => {
				const height = this.$refs.hw.offsetHeight
				this.$emit('getHeaderHeight', height)
			})
			const langCode = localStorage.getItem('TV_LANGUAGE')
			if (langCode) {
				this.currentLang = langCode
			}
		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	.logo-wrap {
		cursor: pointer;
	}

	.mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 102;
		background: rgba(0, 0, 0, 0.5);
	}

	.hamburger {
		position: relative;
		display: none;

		.menu {
			display: flex;
			align-items: center;

			.iconfont {
				cursor: pointer;
				font-size: 24px;
			}
		}

	}

	.nav-bar-middle {
		position: fixed;
		z-index: 999;
		padding-top: 64px;
		top: 0;
		right: 0;
		left: 0;
		background: #051412;

		.nav-close {
			position: absolute;
			cursor: pointer;
			left: 24px;
			top: 20px;
			text-align: center;

			.iconfont {
				font-size: 24px;
			}
		}

		.nav-logo {
			position: absolute;
			left: 50%;
			top: 35px;
			transform: translate(-50%, -50%);
			width: unset;
			height: unset;
		}

		.nav-menu {
			position: relative;
			z-index: 103;
			padding: 0 24px 16px;

			.nav-item {
				font-family: 'Alibaba PuHuiTi R';
				padding: 14px 0;

				.nav-text {
					padding-bottom: 14px;

					.iconfont {
						margin-left: 8px;
					}
				}

				.nav-link-list {
					.link {
						cursor: pointer;
						padding: 14px 16px;
					}

					.link:hover {
						background: #1E2B29;
					}
				}

			}
		}
	}

	.locales-inner {
		display: none;
		cursor: pointer;
		font-size: 24px;
		position: relative;
	}

	.nav-bar-middle {
		display: none;
	}
	.about{
		padding-left: 0 !important;
		padding-right: 24px;
	}
	@media (max-width: 1200px) {}

	@media (max-width: 768px) {
		.hamburger {
			display: block;
		}

		.navbar-with-link {
			display: none !important;
		}

		.nav-bar-middle {
			display: block !important;
		}

		.locales-inner {
			display: block !important;

			.iconfont {
				color: #fff;
				font-size: 24px;
			}
		}

		.nav-dropdown {
			position: absolute;
			z-index: 102;
			background: #282F4A;
			border-radius: 4px 4px 4px 4px;
			border: 1px solid #353C56;
			top: 34px;
			right: 0;
			min-width: 115px;

			.dropdown-item {
				cursor: pointer;
			}

			a {
				font-size: 16px;
				display: block;
				padding: 16px;
			}

			.selected {
				color: #1EF8A0;
			}

			.nav-link:hover {
				background: #374165;
			}
		}
	}
</style>